import React, { Component } from 'react';
import ReactSelect from 'react-select';
import classNames from 'classnames';
import IsMobile from 'is-mobile';
import './dpit-select.scss';

export default class Select extends Component {
	constructor(props) {
		super(props);
		this.isMobile = IsMobile();
	}

	render() {
		let select = null;
		if (this.props.forceNative || this.isMobile) {
			const nativeSelectClass = classNames({
				[this.props.className]: true,
				[`${this.props.classBEMRoot}--native`]: this.props.classBEMRoot,
				[`${this.props.className}--native`]: !this.props.classBEMRoot,
			});
			select = (
				<select
					className={nativeSelectClass}
					value={this.props.value
						? this.props.value.value
						: this.props.defaultValueNative
					}
					onChange={(event) => {
						if (this.props.onChange) {
							this.props.onChange({
								value: event.target.value,
								label: event.target[event.target.selectedIndex].text
							});
						}
					}}
				>
					{
						this.props.options.map((option, i) => (
							<option
								value={option.value}
								defaultValue={this.props.defaultValueNative}
								key={i}
							>
								{option.label}
							</option>
						))
					}
				</select>
			);
		} else {
			select = <ReactSelect {...{ ...this.props, classNamePrefix: this.props.classBEMRoot }} />;
		}
		return select;
	}
}
